import { useEffect } from 'react';
import { createRoot } from 'react-dom/client';

import { Provider } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import polyfill from 'dynamic-polyfill';

import { getPage } from './lib/core';
import { store } from './lib/store';
import { CONFIG } from "./app/config";

import { init } from './app/actions';
import {initCustomHooks} from "./app/hooks";

import Main from './lib/includes/components/component.main';

//sass
import './sass/main.scss';

const route = (props) => {
    if (CONFIG.scrollToTopOnRouteChange) { window.scrollTo(0,0); }
    useEffect(() => {
        getPage(store.dispatch, props.match.params, props.location.hash);
    });

    return <Main></Main>;
};

const container = document.getElementById('root');
const root = createRoot(container);

init();
initCustomHooks();

if (CONFIG.polyfill) {
    polyfill({...CONFIG.polyfill,
        afterFill() {
            __main();
        }
    });
} else {
    __main();
}

function __main() {
    root.render(<Provider store={store}><BrowserRouter>
        <Switch>
            <Route path="/:page?/:sub?/:sub2?/:sub3?/:sub4?/:sub5?/:sub6?" component={route}></Route>
        </Switch>
    </BrowserRouter></Provider>);
}
